<template>
  <div
    class="AiSeparator"
    :class="[
      {
        [`AiSeparator--${color}`]: typeof color === 'string',
        [`AiSeparator--m${margin}`]: typeof margin === 'number',
        'AiSeparator--inverse': inverse,
        'AiSeparator--vertical': vertical,
      },
    ]"
    aria-hidden="true" />
</template>

<script setup lang="ts">
interface AiTypoProps {
  color?: 'gold' | 'stratos' | 'stratos-light' | 'neutral';
  inverse?: boolean;
  margin?: 'none' | 0 | 1 | 2 | 3 | 4;
  vertical?: boolean;
}

withDefaults(defineProps<AiTypoProps>(), {
  color: 'gold',
  inverse: false,
  margin: 4,
  vertical: false,
});
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/utilities/constants';

.AiSeparator {
  &.AiSeparator--m0 {
    margin: constants.$margin-00 0;

    &.AiSeparator--vertical {
      margin: 0 constants.$margin-00;
    }
  }

  &.AiSeparator--m1 {
    margin: constants.$margin-01 0;

    &.AiSeparator--vertical {
      margin: 0 constants.$margin-01;
    }
  }

  &.AiSeparator--m2 {
    margin: constants.$margin-02 0;

    &.AiSeparator--vertical {
      margin: 0 constants.$margin-02;
    }
  }

  &.AiSeparator--m3 {
    margin: constants.$margin-03 0;

    &.AiSeparator--vertical {
      margin: 0 constants.$margin-03;
    }
  }

  &.AiSeparator--m4 {
    margin: constants.$margin-04 0;

    &.AiSeparator--vertical {
      margin: 0 constants.$margin-04;
    }
  }

  &--gold {
    border-bottom: 1px solid colors.$gold-200;
  }

  &--stratos {
    border-bottom: 1px solid colors.$stratos-500;
  }

  &--stratos-light {
    border-bottom: 1px solid colors.$stratos-900;
    opacity: 15%;
  }

  &--neutral {
    border-bottom: 1px solid colors.$neutral-100;
    opacity: 15%;
  }
}

.AiSeparator.AiSeparator--inverse {
  &.AiSeparator--gold {
    border-bottom: 1px solid colors.$gold-700;
  }
}

.AiSeparator.AiSeparator--vertical {
  display: flex;
  border-bottom: none;
  width: 1px;

  &.AiSeparator--gold {
    border-right: 1px solid colors.$gold-500;
  }
}
</style>
